module.exports = "<private-bus-requests-page></private-bus-requests-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/privatebusrequests.html
// module id = 1935
// module chunks = 0